<div 
    class="wrapper"
    (mouseenter)="isMenuOpen = true"
    (mouseleave)="isMenuOpen = false"
>

    <div class="hover-zone" *ngIf="isMenuOpen"></div>
    
    <button 
        #btnTrigger
        mat-button
        class="wrapper-trigger"
    >
        Nova Cotação

    </button>
    
    <div 
        #menu
        class="wrapper-menu"
        *ngIf="isMenuOpen"
    >
        <ul class="wrapper-menu-list">
            <li 
                class="wrapper-menu-list-item"
                *ngFor="let item of menusCotacao"
            >
                <span>{{item.titulo}}</span>

                <ul class="wrapper-menu-list-item-submenu">
                    <li class="wrapper-menu-list-item-submenu-item" (click)="openPage(subItem)" *ngFor="let subItem of item.list">
                        <mat-icon [svgIcon]="subItem.icone"></mat-icon>
                        <span>{{subItem.txt}}</span>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    
</div>